import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { Icon } from '../icon/icon.enum';
import { AppLocalization } from '../entities/app-localization';

@Component({
  selector: 'app-go-offline-sync-screen',
  templateUrl: './go-offline-sync-in-progress-screen.component.html',
  styleUrls: ['./go-offline-sync-in-progress-screen.component.scss'],
  standalone: false
})
export class GoOfflineSyncInProgressScreenComponent implements OnInit {
  appStrings: AppLocalization;
  appIcon: string;

  constructor(
    private appInfoService: AppInfoService,
    private dialogRef: MatDialogRef<GoOfflineSyncInProgressScreenComponent>
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.appIcon = Icon.logo;
  }

  /**
   * Handles the go back online action from button
   */
  goBackOnline() {
    this.dialogRef.close();
  }

}
